// Valores predefinidos que se ofrecen en el Select de Catalog cuando el Servicio de
// aplicación seleccionado no trae ningún catalog de la CMDB. Único punto de verdad:
// el componente y sus tests importan esta constante en vez de repetir los literales.
export const DEFAULT_CATALOG_OPTIONS = [
  'Corporación',
  'Energía',
  'Construcción',
  'Agua',
  'Común',
  'Innovación',
  'Inmobiliaria',
  'Concesiones',
  'Bestinver',
  'Industrial',
  'Infraestructuras',
  'Acciona Airport Service',
  'Acciona Forwarding',
  'Acciona Producciones y Diseño',
  'ASUMA',
  'Mobility',
  'Service'] as const;
